import { Box, styled } from '@mui/material';


const PREFIX = 'CircularProgressWithLabel';

export const circularProgressWithLabelClasses = {
  circleNumberBox: `${PREFIX}-circleNumberBox`,
};

export const StyledCircularProgressBox = styled(Box)({
  [`& .${circularProgressWithLabelClasses.circleNumberBox}`]: {
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
});